module.exports = __webpack_public_path__ + "img/tpc-5.cd5ffc47.webp";